import React, { useState, useEffect } from 'react'
import data from '../../data/portfolioData'


const Portfolio = () => {
    const [nextItems, setNextitems] = useState(3);
    const [portfolios, setPortfolios] = useState(data);
    const [selectTab, setSelectTab] = useState('all');
    const [previewPortfolio, setPreviewPortfolio] = useState(null);

    const loadMoreHandler = () => {
        setNextitems(prev => prev + 3)
    }

    const openPreview = (portfolio) => {
        setPreviewPortfolio(portfolio);
    }

    const closePreview = () => {
        setPreviewPortfolio(null);
    }

    useEffect(() => {
        if (selectTab === 'all') {
            setPortfolios(data);
        }
        if (selectTab === 'web-design') {
            const filteredData = data.filter(item => item.category === 'Web Design')
            setPortfolios(filteredData);
        }
        if (selectTab === 'ux-design') {
            const filteredData = data.filter(item => item.category === 'Ux')
            setPortfolios(filteredData);
        }
        if (selectTab === 'android') {
            const filteredData = data.filter(item => item.category === 'Android')
            setPortfolios(filteredData);
        }
        if (selectTab === 'machine-learning') {
            const filteredData = data.filter(item => item.category === 'Machine Learning')
            setPortfolios(filteredData);
        }
    }, [selectTab])

    return (
        <section id='portfolio'>
            <div className='container'>
                {/* Title & Buttons */}
                <div className='flex items-center justify-between flex-wrap'>
                    <div className='mb-7 sm:mb-0'>
                        <h3 className='text-headingColor text-[2.5rem] font-[700]'>
                            Projects
                        </h3>
                    </div>

                    <div className='flex gap-3 flex-wrap'>
                        <button onClick={() => setSelectTab('all')} className={`${selectTab === 'all' ? 'bg-smallTextColor text-white' : 'bg-transparent text-smallTextColor border border-smallTextColor'} font-[500] gap-2 hover:bg-smallTextColor hover:text-white
                    ease-in duration-200 py-2 px-4 rounded-[8px]`}>
                            All
                        </button>
                        <button onClick={() => setSelectTab('web-design')} className={`${selectTab === 'web-design' ? 'bg-smallTextColor text-white' : 'bg-transparent text-smallTextColor border border-smallTextColor'} font-[500] gap-2 hover:bg-smallTextColor hover:text-white
                    ease-in duration-200 py-2 px-4 rounded-[8px]`}>
                            Website
                        </button>
                        <button onClick={() => setSelectTab('ux-design')} className={`${selectTab === 'ux-design' ? 'bg-smallTextColor text-white' : 'bg-transparent text-smallTextColor border border-smallTextColor'} font-[500] gap-2 hover:bg-smallTextColor hover:text-white
                    ease-in duration-200 py-2 px-4 rounded-[8px]`}>
                            3D Design
                        </button>
                        <button onClick={() => setSelectTab('android')} className={`${selectTab === 'android' ? 'bg-smallTextColor text-white' : 'bg-transparent text-smallTextColor border border-smallTextColor'} font-[500] gap-2 hover:bg-smallTextColor hover:text-white
                    ease-in duration-200 py-2 px-4 rounded-[8px]`}>
                            Android
                        </button>
                        <button onClick={() => setSelectTab('machine-learning')} className={`${selectTab === 'machine-learning' ? 'bg-smallTextColor text-white' : 'bg-transparent text-smallTextColor border border-smallTextColor'} font-[500] gap-2 hover:bg-smallTextColor hover:text-white
                    ease-in duration-200 py-2 px-4 rounded-[8px]`}>
                            Machine Learning
                        </button>
                    </div>
                </div>

                <div className='flex items-center gap-4 flex-wrap mt-12'>
                    {
                        portfolios?.slice(0, nextItems).map((portfolio, index) => (
                            <div key={index} data-aos='fade-zoom-in' data-aos-delay='50' data-aos-duration='1000' className='group max-w-full sm:w-[48.5%] md:w-[31.8%] lg:w-[32.2%] relative z-[1]'>
                                <figure><img className='rounded-[8px]' src={portfolio.imgUrl} alt='' /></figure>

                                <div className='w-full h-full bg-primaryColor bg-opacity-40 absolute top-0 left-0 z-[5] hidden group-hover:block rounded-[8px]'>
                                    <div className='w-full h-full flex items-center justify-center'>
                                        <button
                                            onClick={() => openPreview(portfolio)}
                                            className='text-white bg-headingColor hover:bg-smallTextColor py-2 px-4 rounded-[8px] 
                                        font-[500] ease-in duration-200 cursor-pointer'>
                                            Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className='text-center mt-6'>
                    {nextItems < portfolios.length && data.length > 6 && (
                        <button onClick={loadMoreHandler}
                            className='bg-smallTextColor bg-black text-white font-[500] gap-2 hover:bg-smallTextColor
                     ease-in duration-100 py-2 px-4 rounded-[8px]'>Load More</button>
                    )}
                </div>
            </div>

            {/* ===== Image Preview Modal ===== */}
            {previewPortfolio && (
                <div
                    className='fixed inset-0 z-50 flex items-center justify-center p-4'
                    onClick={closePreview}
                >
                    {/* Backdrop */}
                    <div className='absolute inset-0 bg-black bg-opacity-70 backdrop-blur-sm'></div>

                    {/* Modal Content */}
                    <div
                        className='relative z-10 bg-white rounded-2xl shadow-2xl max-w-[800px] w-full max-h-[90vh] overflow-hidden'
                        onClick={(e) => e.stopPropagation()}
                        style={{ animation: 'modalFadeIn 0.3s ease-out' }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={closePreview}
                            className='absolute top-3 right-3 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-black bg-opacity-50 hover:bg-opacity-80 text-white transition-all duration-200 text-lg font-bold'
                        >
                            ✕
                        </button>

                        {/* Image */}
                        <div className='w-full overflow-hidden'>
                            <img
                                src={previewPortfolio.imgUrl}
                                alt={previewPortfolio.title}
                                className='w-full h-auto max-h-[60vh] object-contain bg-gray-100'
                            />
                        </div>

                        {/* Info & Buttons */}
                        <div className='p-5'>
                            <h3 className='text-headingColor text-xl font-[700] mb-1'>
                                {previewPortfolio.title}
                            </h3>
                            <span className='inline-block bg-primaryColor bg-opacity-20 text-primaryColor text-[13px] font-[500] px-3 py-1 rounded-full mb-3'>
                                {previewPortfolio.category}
                            </span>
                            <p className='text-smallTextColor text-[14px] leading-6 mb-4'>
                                {previewPortfolio.description}
                            </p>

                            {/* Technologies */}
                            <div className='flex items-center gap-2 flex-wrap mb-5'>
                                {previewPortfolio.technologies.map((tech, idx) => (
                                    <span key={idx} className='bg-gray-100 text-smallTextColor py-1 px-3 rounded-full text-[12px] font-[500]'>
                                        {tech}
                                    </span>
                                ))}
                            </div>

                            {/* Action Buttons */}
                            <div className='flex items-center gap-3'>
                                {previewPortfolio.siteUrl && previewPortfolio.siteUrl !== '#' && (
                                    <a
                                        href={previewPortfolio.siteUrl}
                                        target='_blank'
                                        rel='noreferrer'
                                        className='bg-primaryColor hover:bg-opacity-80 text-white font-[500] py-2.5 px-6 rounded-[8px] ease-in duration-200 inline-flex items-center gap-2'
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                        Kunjungi
                                    </a>
                                )}
                                <button
                                    onClick={closePreview}
                                    className='bg-gray-200 hover:bg-gray-300 text-headingColor font-[500] py-2.5 px-6 rounded-[8px] ease-in duration-200'
                                >
                                    Tutup
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Animation Keyframes */}
            <style>{`
                @keyframes modalFadeIn {
                    from {
                        opacity: 0;
                        transform: scale(0.9) translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1) translateY(0);
                    }
                }
            `}</style>
        </section>
    );
}

export default Portfolio;
